import React from "react";

//logo import
import logowithoutwords from "../../../assets/newCWlogowhite.png";

const Hero = () => {
  return (
    <div className="logo-container">
      <img
        fetchPriority="high"
        loading="eager"
        src={logowithoutwords}
        alt="Concierge Wellness logo"
        style={{ height: "auto", width: "50%" }}
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      />
      <div
        className="brand-text"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-easing="ease-in-out"
      >
        <h4>
          Expert wellness care from a collaborative team of movement and
          recovery specialists. <br></br> Telehealth services available.
        </h4>
      </div>
    </div>
  );
};

export default Hero;
